// The automation app (apps/automation), for what the webapp only summarizes (the IoT alerts). It has its own
// host per environment; REACT_APP_ENV tells stage from production (NODE_ENV is "production" in every build).
export const AUTOMATION_ORIGINS = {
  staging: "https://stage-automation.wine2trace.com",
  production: "https://automation.wine2trace.com",
};
export const AUTOMATION_ORIGIN =
  process.env.NODE_ENV === "production"
    ? AUTOMATION_ORIGINS[process.env.REACT_APP_ENV] || AUTOMATION_ORIGINS.production
    : "http://localhost:3001";

// A page of automation on the given winery: automation selects it from ?winery=<id> if it is one of the user's.
export const automationUrl = (path, wineryId) => {
  const url = new URL(path, AUTOMATION_ORIGIN);
  if (wineryId != null) url.searchParams.set("winery", String(wineryId));
  return url.toString();
};
